import { render } from "./IconInboxEmpty.vue?vue&type=template&id=357b8f56"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconInboxEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "357b8f56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('357b8f56', __exports__)) {
    api.reload('357b8f56', __exports__)
  }
  
  module.hot.accept("./IconInboxEmpty.vue?vue&type=template&id=357b8f56", () => {
    api.rerender('357b8f56', render)
  })

}


export default __exports__